import React from 'react'
import { Fab, Tooltip, Zoom } from '@mui/material'
import WhatsAppIcon from '@mui/icons-material/WhatsApp'
import { trackCTA } from '../utils/analytics'
import { trackPixelLead } from '../utils/metaPixel'

const WHATSAPP_URL = `https://wa.me/5212225052136?text=${encodeURIComponent('Hola 👋 Estaba viendo Laiten y me interesa para mi negocio. ¿Me cuentan cómo funciona?')}`

// Floating WhatsApp button shown across all Laiten landing routes.
const FloatingWhatsApp = () => {
  const handleClick = () => {
    trackCTA('floating_whatsapp', 'global')
    trackPixelLead({ content_name: 'WhatsApp', source: 'floating_button' })
  }

  return (
    <Tooltip title='Escríbenos por WhatsApp' placement='left' arrow TransitionComponent={Zoom}>
      <Fab
        aria-label='Contactar por WhatsApp'
        href={WHATSAPP_URL}
        target='_blank'
        rel='noopener'
        onClick={handleClick}
        sx={{
          position: 'fixed',
          bottom: { xs: 20, md: 28 },
          right: { xs: 20, md: 28 },
          zIndex: 1300,
          bgcolor: '#25D366',
          color: '#fff',
          boxShadow: '0 8px 24px rgba(37,211,102,0.45)',
          '&:hover': { bgcolor: '#1da851' }
        }}
      >
        <WhatsAppIcon />
      </Fab>
    </Tooltip>
  )
}

export default FloatingWhatsApp
